import { useMemo } from 'react';
import useSWR from 'swr';
import axios from 'axios';

import useToken from './useToken';

const API_BASE_URL = process.env.NEXT_PUBLIC_API_URL;

export default function useClaims(accountId) {
  const {
    headers,
    loading: tokenLoading,
    error: tokenError,
  } = useToken();

  const shouldFetch =
    !!accountId && !!headers && typeof API_BASE_URL === 'string';

  const fetcher = async () => {
    const { data } = await axios.post(
      `${API_BASE_URL}/claims`,
      { account_id: accountId },
      { headers }
    );
    return data;
  };

  const {
    data,
    error: claimsError,
    isValidating,
    mutate,
  } = useSWR(shouldFetch ? ['claims', accountId] : null, fetcher, {
    revalidateOnFocus: false,
  });

  const claims = useMemo(() => {
    if (!data?.Items) {
      return [];
    }
    return [...data.Items].sort(
      (a, b) => new Date(b.date_of_claim) - new Date(a.date_of_claim)
    );
  }, [data]);

  const combinedError = tokenError || claimsError || null;
  const isLoading = shouldFetch
    ? tokenLoading || (!data && !combinedError)
    : false;

  return {
    claims,
    isLoading,
    isValidating,
    error: combinedError,
    mutate,
  };
}
